import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';

export { Tab };
export default Tabs;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tabs/index.ts